module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_6000.d72d2121.png";